import SearchInput from "../../components/inputs/searchInput";
import { useFormik } from "formik";
import SearchSelect from "../../components/select/searchSelect";
import { useOptions } from "../../components/hooks/useOptionsHook";

const SearchStore = ({ t }) => {
  const formik = useFormik({ initialValues: {} });
  const { memberShipTypeOptions, memberStatusOptions } = useOptions();

  return (
    <section className="flex flex-wrap items-center justify-between gap-3 md:flex-nowrap">
      <div className="flex flex-wrap items-center w-full gap-3 md:w-auto md:flex-nowrap">
        <SearchInput
          formik={formik}
          name={"search"}
          placeholder={t("searchWithName")}
        />
        <SearchSelect
          options={memberShipTypeOptions}
          formik={formik}
          name={"category"}
          placeholder={t("category")}
        />
        <SearchSelect
          options={memberStatusOptions}
          formik={formik}
          name={"status"}
          placeholder={t("status")}
        />
      </div>
      <div>
        <SearchSelect
          options={memberShipTypeOptions}
          formik={formik}
          name={"download"}
          placeholder={t("downloadFile")}
        />
      </div>
    </section>
  );
};

export default SearchStore;
